import { Box } from '@mui/material';

export default function GenericError() {
  return (
    <Box
      alignItems="center"
      display="flex"
      flex="1 1"
      flexDirection="column"
      justifyContent="center"
    >
      <Box marginTop="40px" fontWeight="700" fontSize="60px" textAlign="center">
        Что-то пошло не так
      </Box>

      <Box marginTop="20px" fontSize="16px" textAlign="center">
        Что-то пошло не так, но мы уже об этом знаем.
        <br />
        Если хотите что-то добавить, то напишите нам на{' '}
        <Box
          component="a"
          color="primary"
          href="mailto:tech_support.audience@x5.ru"
        >
          tech_support.audience@x5.ru
        </Box>
      </Box>
    </Box>
  );
}
